export default __webpack_public_path__ + "static/media/Selected_0.ee13caff.svg";